import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { map, Observable } from 'rxjs';
import { ProductAttributeTable, ProductCertification, ProductDetailsTopic } from '../../../../core/model';
import { Occ } from '../../../../core/occ';
import { ProductRelations } from '../../../../core/occ/occ-models/occ-generated.models';
import { AssortmentTable } from '../models';
import { PRODUCT_ASSORTMENT_TABLE_NORMALIZER, PRODUCT_ATTRIBUTE_TABLE_NORMALIZER } from './converters';

@Injectable({ providedIn: 'root' })
export class ProductDetailsConnector {
  constructor(
    protected httpClient: HttpClient,
    protected occEndpointsService: OccEndpointsService,
    protected converterService: ConverterService
  ) {}

  getTechnicalDataTable(userId: string, productCode: string): Observable<ProductAttributeTable> {
    return this.getProductDetails<Occ.ProductDetails>(userId, productCode, ProductDetailsTopic.TECHNICAL_DATA_TABLE).pipe(
      map((data) => data.technicalDataTable),
      this.converterService.pipeable(PRODUCT_ATTRIBUTE_TABLE_NORMALIZER)
    );
  }

  getAssortmentTable(userId: string, productCode: string): Observable<AssortmentTable> {
    return this.getProductDetails<Occ.ProductDetails>(userId, productCode, ProductDetailsTopic.ASSORTMENT_PACKAGING_TABLE).pipe(
      map((data) => data.assortmentPackagingTable),
      this.converterService.pipeable(PRODUCT_ASSORTMENT_TABLE_NORMALIZER)
    );
  }

  getCertLabels(userId: string, productCode: string): Observable<ProductCertification> {
    return this.getProductDetails<Occ.ProductDetails>(userId, productCode, ProductDetailsTopic.CERT_LABELS).pipe(
      map((data) => data.certLabels)
    );
  }

  getRelatedItems(userId: string, productCode: string): Observable<ProductRelations> {
    return this.getProductDetails<Occ.ProductDetails>(userId, productCode, ProductDetailsTopic.RELATED_ITEMS).pipe(
      map((data) => data.relatedItems)
    );
  }

  protected getProductDetails<T>(userId: string, productCode: string, topic: ProductDetailsTopic): Observable<T> {
    return this.httpClient.get<T>(
      this.occEndpointsService.buildUrl('productDetails', {
        urlParams: { userId, productCode, topic: topic.toLowerCase().replace(/_/g, '-') },
      })
    );
  }
}
